export default "__VITE_ASSET__DX0hgSby__"